(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[23058],{

/***/ 87964:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/aisoSettings/payment",
      function () {
        return __webpack_require__(70706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageTokenCheck; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var function_LogOut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39222);




/* 회원 비회원 token 값 체크 */ var PageTokenCheck = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(settings, router) {
        var tokenValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            if (tokenValue === "" || tokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
                // window.localStorage.removeItem("aisoToken");
                router.push("/user/market");
                ;
            } else {
                /* 만료된 토큰인지 체크해야함 */ // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch", function(error, decoded) {
                    ;
                    if (error) {
                        /* 만료된 토큰임. token 삭제하기 */ // window.localStorage.removeItem("aisoToken");
                        (0,function_LogOut__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(settings);
                        router.push("/user/market");
                    } else {
                        var email = decoded.email, name = decoded.name, uid = decoded.uid;
                        settings.login = true;
                        settings.email = email;
                        settings.name = name;
                        settings.uid = uid;
                        var setTokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign({
                            email: email,
                            name: name,
                            uid: uid
                        }, "sdkjkdlsAESRcdslkch", {
                            expiresIn: "1d"
                        });
                        window.localStorage.setItem("aisoToken", setTokenValue);
                        if (router && router.asPath === "/") {
                            router.push("/user/market");
                        } else {
                            router.push(router.asPath);
                        }
                    }
                });
            }
            return [
                2
            ];
        });
    });
    return function PageTokenCheck(settings, router) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 70706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89518);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/** @format */ 




var Payment = function() {
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    /* 로그인 체크 : url 이동 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_3__/* .PageTokenCheck */ .C)(settings, router);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "checkout",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "credit-card-box",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flip",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "front",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "chip"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "logo pt-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/images/visa-icon.png",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "number",
                                        children: "1234 1234 1234 1234"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "card-holder",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                children: "VALID THRU"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "SHIN YEJIN"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "card-expiration-date",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                children: "MONTH / YEAR"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "08/23"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "back",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "strip"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "logo sm:pt-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/images/visa-icon.png",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ccv",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                children: "CCV"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "888"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    className: "form",
                    autoComplete: "off",
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: "card-number",
                                    children: "Card Number"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "num",
                                    id: "card-number",
                                    className: "input-cart-number",
                                    maxLength: "4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "num",
                                    id: "card-number-1",
                                    className: "input-cart-number",
                                    maxLength: "4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "num",
                                    id: "card-number-2",
                                    className: "input-cart-number",
                                    maxLength: "4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "num",
                                    id: "card-number-3",
                                    className: "input-cart-number",
                                    maxLength: "4"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "btn btn-primary w-full",
                            children: "등록"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Payment);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,92888,40179], function() { return __webpack_exec__(87964); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);